import { render, staticRenderFns } from "./AutomaticInformPayloadModal.vue?vue&type=template&id=6efdd5d6&"
import script from "./AutomaticInformPayloadModal.vue?vue&type=script&lang=js&"
export * from "./AutomaticInformPayloadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports